import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { programConstrainedByIdQuery } from '../constants/queries';
import { useToastContext } from '../components/UI/ToastManager';

export type ProgramConstrainedByIdQueryResponse = {
  programConstrained: {
    id: string;
    name: string;
    status: string;
    lastUpdateDate: Date;
    constraints: {
      gender: string[];
      sport: string[];
      userLevel: string[];
      category: string[];
      material: string[];
      specialProgram: string[];
      pathology: string[];
      weekFocus: string[];
    };
    description: {
      language: string;
      text: string;
    }[];
    displayName: {
      language: string;
      text: string;
    }[];
    poster: {
      height: number;
      source: string;
      width: number;
    };
    steps: {
      name: string;
      repetitions: number;
      duration: number;
      displayName: {
        language: string;
        text: string;
      }[];
              options: {
          id: string;
          name: string;
          displayName: {
            language: string;
            text: string;
          }[];
          duration: number;
          repetitions: number;
        constraints: {
          gender: string[];
          sport: string[];
          userLevel: string[];
          category: string[];
          material: string[];
          specialProgram: string[];
          pathology: string[];
          weekFocus: string[];
        };
        exercises: {
          id: string;
          duration: number;
          recuperation: number;
          repetitions: number;
          series: number;
          constraints: {
            gender: string[];
            sport: string[];
            userLevel: string[];
            category: string[];
            material: string[];
            specialProgram: string[];
            pathology: string[];
            weekFocus: string[];
          };
          options: {
            id: string;
            duration: number;
            recuperation: number;
            repetitions: number;
            series: number;
            exercise: {
              id: string;
              name: string;
              lastUpdateDate: Date;
              sideChange: boolean;
              description: {
                language: string;
                text: string;
              }[];
              displayName: {
                language: string;
                text: string;
              }[];
              poster: {
                source: string;
                height: number;
                width: number;
              };
              backgroundVideo: {
                duration: number;
                source: string;
                title: string;
              };
              videos: {
                language: string;
                video: {
                  duration: number;
                  height: number;
                  source: string;
                  title: string;
                  width: number;
                };
              }[];
            };
            constraints: {
              gender: string[];
              sport: string[];
              userLevel: string[];
              category: string[];
              material: string[];
              specialProgram: string[];
              pathology: string[];
              weekFocus: string[];
            };
          }[];
        }[];
      }[];
    }[];
  };
};

export function useProgramConstrainedByIdQuery(id: string | null) {
  const { showError } = useToastContext();

  return useQuery<ProgramConstrainedByIdQueryResponse['programConstrained']>({
    queryKey: ['programConstrained', id],
    queryFn: () =>
      graphqlRequest<ProgramConstrainedByIdQueryResponse>(programConstrainedByIdQuery, { id }, showError).then(({ programConstrained }) => programConstrained),
    enabled: !!id,
  });
} 